module.exports = __webpack_public_path__ + "static/media/micaela-arce.53be0b75.jpg";